import PropTypes from "prop-types";

import { Button } from "@transfr-inc/dashboard-components/forms";

import { Card, CardBody, CardFooter, CardHeader, Modal } from "@features/ui";

import { buttonTracking } from "@lib/tracking.helpers";

import "./start-over-confirmation.modal.scss";

export const StartOverConfirmationModal = ({
  open,
  onClose,
  onConfirm,
  onCancel,
  career,
  isNewCareer,
  trackingPrefix,
}) => {
  const trackingId = `${trackingPrefix}-start-over-confirmation-modal`;
  const toolbar = (
    <Button
      icon={["fa-regular", "xmark"]}
      onClick={onClose}
      {...buttonTracking(trackingId, "close")}
    />
  );

  const message = isNewCareer ? (
    <span>
      Would you like to setup goals for this new career and erase your previous
      goals for <strong>{career?.title}</strong>?. This can&apos;t be undone.
    </span>
  ) : (
    <span>
      Would you like to start Trek from the beginning? We will remove your
      previous pathway and goals for <strong>{career?.title}</strong>. This
      can&apos;t be undone.
    </span>
  );

  return (
    <Modal
      key="start-over-modal"
      modalClassName="start-over-confirmation-modal"
      open={open}
    >
      <Card>
        <CardHeader title={<h1>Start Over?</h1>} toolbar={toolbar} />
        <CardBody>{message}</CardBody>
        <CardFooter>
          <Button
            destructive
            onClick={onConfirm}
            {...buttonTracking(trackingId, "yes")}
          >
            Yes, start over
          </Button>
          <Button onClick={onCancel} {...buttonTracking(trackingId, "no")}>
            No, cancel
          </Button>
        </CardFooter>
      </Card>
    </Modal>
  );
};

StartOverConfirmationModal.displayName = "Start Over Confirmation Modal";

StartOverConfirmationModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  career: PropTypes.shape({
    title: PropTypes.string,
  }),
  isNewCareer: PropTypes.bool,
  trackingPrefix: PropTypes.string,
};
